import { create } from 'zustand';

import type { ProposalChangesPanelState } from './proposalChangesState';

export const PROPOSAL_CHANGES_PANEL_STORE = create<ProposalChangesPanelState>((set) => ({
  panels: {},

  open: (projectId: string) =>
    set((state) => ({
      panels: { ...state.panels, [projectId]: { open: true } }
    })),

  close: (projectId: string) =>
    set((state) => ({
      panels: { ...state.panels, [projectId]: { open: false } }
    })),

  toggle: (projectId: string) =>
    set((state) => ({
      panels: { ...state.panels, [projectId]: { open: !state.panels[projectId]?.open } }
    }))
}));
